<template>
  <div>
    <h2>ПОД-10+</h2>
    <el-form
      :model="pod10Form"
      ref="formedForm"
      label-position="top"
      label-width="120px"
    >
      <el-form-item label="Период">
        <el-row :gutter="10">
          <el-col :span="6">
            <el-date-picker
              style="width: 100%"
              value-format="yyyy-MM"
              v-model="reportForm.startDate"
              type="month"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </el-col>
        </el-row>
      </el-form-item>

      <el-row :gutter="10">
        <el-col :span="24">
          <el-tree
            :data="orgL"
            show-checkbox
            node-key="id"
            :ref="'tree'"
            :props="defaultProps"
            style="font-weight: bold"
          >
          </el-tree>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="4">
          <el-row>
            <el-form-item label="Тип файла">
              <el-select
                clearable
                v-model="reportForm.fileType"
                placeholder="Формат отчета"
              >
                <el-option
                  v-for="item in fileTypes"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-row>
          <el-row>
            <el-button
              @click="downloadReport('POD-10+')"
              type="primary"
              style="margin-left: 10px"
              >Сформировать отчет</el-button
            >
          </el-row>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { AXIOS } from "@/AXIOS/http-common";
import { mapGetters } from "vuex";
import Cookies from "js-cookie";

export default {
  name: "POD-10Report2023AnyObject",
  data() {
    return {
      pickerOptions:{
        firstDayOfWeek: 1
      },
      orgsList: [],
      orgL: [],
      defaultProps: {
        children: "children",
        label: "name",
      },
      role: Cookies.get("role"),
      pod10Form: null,
      props: {
        id: "id",
        label: "name",
        children: "zones",
      },
      reportForm: {
        organizationUnit: {},
        responsiblePerson: {},
        inspector: {},
        administrativeDocument: {},
        startDate: null,
        endDate: null,
        date: null,
        fileType: null,
      },

      fileTypes: [
        {
          value: ".pdf",
          label: ".pdf",
        },
        {
          value: ".xls",
          label: ".xls",
        },
      ],
    };
  },

  computed: {
    ...mapGetters({
      organizationHierarchyByType: "GETORGANIZATIHIERARCHYBYTYPE",
      listDocumentNumbers: "GETLISTDOCUMENTNUMBERS",
      listResponsiblePersonForSelect: "GETLISTRESPONSIBLEPERSONFORSEARCH",
    }),
  },

  methods: {
    changeOrg() {
      this.getListResponsiblePersonForSelect();
    },

    handleCheckChange(data, checked, indeterminate) {
      console.log(data, checked, indeterminate);
    },

    loadNode(node, resolve) {
      if (node.level === 0) {
        return resolve([
          { id: 0, name: "Root1" },
          { id: 0, name: "Root2" },
        ]);
      }
      console.log(node);
      console.log(resolve);
    },

    downloadReport(NAME) {
      let d1 = new Date(this.reportForm.startDate);
      let d2 = new Date(
        new Date(
          new Date(this.reportForm.startDate).setMonth(
            new Date(this.reportForm.startDate).getMonth() + 1
          )
        ).setDate(0)
      );
      let data = {
        documentId: this.reportForm.administrativeDocument.id,
        date: this.reportForm.date,
        startDate:
          (d1.getDate() < 10 ? "0" + d1.getDate() : d1.getDate()) +
          "." +
          (d1.getMonth() < 10 ? "0" + (d1.getMonth() + 1) : d1.getMonth() + 1) +
          "." +
          d1.getFullYear(),
        endDate:
          (d2.getDate() < 10 ? "0" + d2.getDate() : d2.getDate()) +
          "." +
          (d2.getMonth() < 10 ? "0" + (d2.getMonth() + 1) : d2.getMonth() + 1) +
          "." +
          d2.getFullYear(),
        Organization: this.$refs.tree.getCheckedNodes(),
        fileType: this.reportForm.fileType,
        reportName: NAME,
      };
      this.$store.dispatch("downloadAnyReports", data);
    },

    searchDocumentNumber(query) {
      this.$store.dispatch("getDocsNumbersSearch", { query: query });
    },

    getOrganizationHierarchyByType() {
      this.$store.dispatch("getOrganizationHierarchyByType", {
        type: 3,
      });
    },

    getListResponsiblePersonForSelect() {
      console.log(this.reportForm.organizationUnit);
      let units = [];
      if (this.reportForm.organizationUnit !== null) {
        units.push(this.reportForm.organizationUnit.id);
      }
      this.$store.dispatch("getListResponsiblePersonForSelect", units);
    },

    orgsl() {
      let orgsl = [
        {
          id: this.orgsList[0].id,
          name: this.orgsList[0].name,
          children: [],
          disabled: false,
        },
      ];
      this.orgsList.forEach((element) => {
        if (element.parent == orgsl[0].id)
          orgsl[0].children.push({
            id: element.id,
            name: element.name,
            children: [],
            disabled: false,
          });
      });
      orgsl[0].children.forEach((child) => {
        this.orgsList.forEach((element) => {
          if (element.parent == child.id)
            child.children.push({
              id: element.id,
              name: element.name,
              children: [],
              disabled: false,
            });
        });
        child.children.forEach((child2) => {
          this.orgsList.forEach((element) => {
            if (element.parent == child2.id)
              child2.children.push({
                id: element.id,
                name: element.name,
                children: [],
                disabled: false,
              });
          });
        });
      });
      return orgsl;
    },
  },

  async mounted() {
    this.getOrganizationHierarchyByType();
    this.searchDocumentNumber("");
    this.getListResponsiblePersonForSelect(-1);
    await AXIOS.get("user/organization/hierarchyOrgByWaste?waste=0").then(
      async (response) => {
        this.orgsList = response.data;
        this.orgL = this.orgsl();
      }
    );
  },
};
</script>

<style scoped></style>
